export const environment = {
  production: true,
  appName:"مكتبة اوراق",

  // source:'http://108.181.192.149:4013/',
  // baseURL:'http://108.181.192.149:4013/api',

  source:'https://paper-library.md-soft.app/',
  baseURL:'https://paper-library.md-soft.app/api',

  bundleId:"iraqsoft.paperlibrary.app",
  firebaseTopic:'-paper-library'


};
